import React from 'react';
import classNames from 'classnames';

export const AuthPanel: React.FC<{ width?: 'xl' | '4xl' }> = ({
  children,
  width = 'xl',
}) => {
  return (
    <div
      className={classNames('mx-auto px-8 py-8 bg-white shadow rounded-lg', {
        'max-w-xl': width === 'xl',
        'max-w-4xl': width === '4xl',
      })}
    >
      {children}
    </div>
  );
};
